import axios from "axios";
import { Auth } from "aws-amplify";
import { APP_ID, APP_KEY, URL } from "./variableHelper";

const threeScaleAuth = { app_id: APP_ID, app_key: APP_KEY };

/**
 * Varias pantallas arman la cabecera con un token guardado en el estado del
 * componente, que en la primera carga todavia no esta resuelto: la peticion sale
 * con "Bearer " vacio. Mientras los endpoints no exigian autenticacion eso pasaba
 * inadvertido; contra un endpoint protegido devuelve 401.
 *
 * Aqui se completa la cabecera cuando llega vacia o ausente, que es el unico caso
 * en que un token en blanco puede ser intencional: ninguno. Si ya viene un token,
 * no se toca. Se lee la sesion directamente de Amplify -y no de userHelper- para
 * no crear un ciclo de importacion.
 */
const tokenVigente = async (): Promise<string> => {
  try {
    const usuario = await Auth.currentAuthenticatedUser();
    return usuario?.signInUserSession?.idToken?.jwtToken ?? "";
  } catch (e) {
    return "";
  }
};

export const conAutorizacion = async (headers?: any) => {
  const cabeceras = { ...(headers ?? {}) };
  const declarado = typeof cabeceras.Authorization === "string" ? cabeceras.Authorization.replace(/^Bearer\s*/i, "").trim() : "";
  // "undefined" y "[object Promise]" llegan aqui cuando la pantalla interpola una
  // variable sin resolver: no son tokens, aunque no esten vacios.
  const noEsToken = !declarado || ["undefined", "null", "[object promise]"].includes(declarado.toLowerCase());
  if (!noEsToken) {
    return cabeceras;
  }
  const token = await tokenVigente();
  if (token) {
    cabeceras.Authorization = `Bearer ${token}`;
  }
  return cabeceras;
};
export async function postAPI<T>(apiEndPoint: string, data?: any, headers?: any, params?: any) {
  let result = await axios.post(`${apiEndPoint}`, data, { headers: { ...(await conAutorizacion(headers)), ...threeScaleAuth }, params: params });
  let resultado = procesarResultado(result);

  return resultado;
}

export const patchAPI = async (apiEndPoint: string, data?: any, headers?: any) => {
  let result = await axios.patch(`${URL}${apiEndPoint}`, data, { headers: { ...(await conAutorizacion(headers)), ...threeScaleAuth } });
  let resultado = procesarResultado(result);

  return resultado;
};

export const putAPI = async (apiEndPoint: string, data?: any, headers?: any) => {
  let result = await axios.put(`${URL}${apiEndPoint}`, data, { headers: { ...(await conAutorizacion(headers)), ...threeScaleAuth } });
  let resultado = procesarResultado(result);

  return resultado;
};

export const deleteAPI = async (apiEndPoint: string, headers?: any, params?: any) => {
  let result = await axios.delete(`${apiEndPoint}`, { params: params, headers: { ...(await conAutorizacion(headers)), ...threeScaleAuth } });
  let resultado = procesarResultado(result);

  return resultado;
};
export async function getAPI(apiEndPoint: string, headers?: any, params?: any) {
  let result = await axios.get(`${apiEndPoint}`, { params: params, headers: { ...(await conAutorizacion(headers)), ...threeScaleAuth } });
  let resultado = procesarResultado(result);

  return resultado;
}

export async function getAPIBatch(urls: string[], headers?: any, params?: any) {
  let l_msg: any[] = [];
  const cabeceras = await conAutorizacion(headers);
  const requests = urls.map((url) => {
    return axios.get(url, { params: params, headers: { ...cabeceras, ...threeScaleAuth } });
  });
  let responses = await axios.all(requests);
  responses.forEach((resp) => {
    let msg = {
      server: resp.headers.server,
      status: resp.status,
      data: resp.data,
    };
    l_msg.push(msg);
  });

  return l_msg;
}

export async function getAPIBlob(apiEndPoint: string, headers?: any, params?: any) {
  try {
    let result = await axios.get(`${apiEndPoint}`, {
      timeout: 1000000,
      responseType: "blob",
      params: params,
      headers: { ...(await conAutorizacion(headers)), ...threeScaleAuth },
    });
    let resultado = procesarResultado(result);

    return resultado;
  } catch (error: any) {
    throw error;
  }
}

export async function getAPIBlobByPost(apiEndPoint: string, headers?: any, params?: any) {
  let result = await axios.post(`${apiEndPoint}`, params, { responseType: "blob", headers: { ...(await conAutorizacion(headers)), ...threeScaleAuth } });
  let resultado = procesarResultado(result);

  return resultado;
}

function procesarResultado(result: any) {
  if (result !== undefined) {
    let statusCode = result.status;
    let resultado = result.data;

    let procesado = { httpCode: statusCode, result: resultado };

    return procesado;
  } else {
    return { httpCode: 500, result: undefined };
  }
}
